import { Pipe, PipeTransform } from '@angular/core';
import {
  TeamMember,
  TeamPermission,
  TeamRole,
  fullName,
  initials,
  permissionLabel,
  roleLabel,
} from './team-member.model';

// Pure pipes wrapping the model helpers, so templates (especially the hot
// management board) memoise the result instead of recomputing it every change
// detection cycle. The logic still lives in one place — team-member.model.ts.

@Pipe({ name: 'memberFullName' })
export class MemberFullNamePipe implements PipeTransform {
  transform(member: TeamMember | null | undefined): string {
    return member ? fullName(member) : '';
  }
}

@Pipe({ name: 'memberInitials' })
export class MemberInitialsPipe implements PipeTransform {
  transform(member: TeamMember | null | undefined): string {
    return member ? initials(member) : '?';
  }
}

@Pipe({ name: 'roleLabel' })
export class RoleLabelPipe implements PipeTransform {
  transform(role: TeamRole): string {
    return roleLabel(role);
  }
}

@Pipe({ name: 'permissionLabel' })
export class PermissionLabelPipe implements PipeTransform {
  transform(permission: TeamPermission | null | undefined): string {
    return permissionLabel(permission ?? TeamPermission.Unknown);
  }
}
